import { Routes, Route } from 'react-router';
import { TrackingDiagramPage } from './tracking-diagram-page';
import { TrackingDetailsPage } from './tracking-details-page';
import { SubDomain } from './sources/sub-domain';
import { ShopifyTrackingDetails } from './sources/shopify/shopify-tracking-details';
export function TrackingPage() {
  return (
    <Routes>
      <Route path="" element={<TrackingDiagramPage />} />
      <Route path="shopify" element={<ShopifyTrackingDetails />} />
      <Route path="sub-domain" element={<SubDomain />} />
      <Route path="integrations/:id/:tab?" element={<TrackingDetailsPage />} />
    </Routes>
  );
}
